import { css } from '@emotion/react';

export const useStyles = (props) => ({
    barcodeIcon: css({
        fontSize: "90px !important",
        width: "90px !important",
        height: "90px !important",
    }),
    arrowDownIcon: css({
        fontSize: "19px !important",
        width: "19px !important",
        height: "19px !important",
        color: "#d0d0d0 !important",
        "& svg": {
            color: "#d0d0d0 !important",
        },
        marginTop: "40px",
        marginBottom: "40px",
    }),
    noPreviewContent: css({
        textAlign: "center",
        fontSize: "14px"
    })
});
